import { MDBDataTable } from "mdbreact";
import React, { useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { carrier_type, rack_status } from "../../constants/racks_fields";
import EntriesSelector from "../tableServerPagination/entriesSelector";
import PaginationButtons from "../tableServerPagination/paginationButtons";

const RackList = function(props) {

  const [size, setSize] = useState(100);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [carrierTypeFilter, setCarrierTypeFilter] = useState("");
  const searchTimeout = useRef(null);
  const user = JSON.parse(localStorage.getItem("authUser"));

  // P01021-143: búsqueda/filtro por servidor (código/posición, estado, tipo de carrier),
  // sobre todo el dataset, mismo patrón usado en MapList para el mapa.
  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      props.getRacks(user, size, 1, status, carrierTypeFilter, value);
    }, 400);
  };

  const handleStatusChange = (value) => {
    setStatus(value);
    setPage(1);
    props.getRacks(user, size, 1, value, carrierTypeFilter, search);
  };

  const handleCarrierTypeChange = (value) => {
    setCarrierTypeFilter(value);
    setPage(1);
    props.getRacks(user, size, 1, status, value, search);
  };

    return (
      <React.Fragment>
        <Row className="mb-3">
          <Col md={4}>
            <FormGroup className="mb-0">
              <Label htmlFor="rackSearch">{props.t("Search")}</Label>
              <Input
                type="text"
                id="rackSearch"
                placeholder={props.t("Search")}
                defaultValue={search}
                onChange={(e) => handleSearchChange(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="mb-0">
              <Label htmlFor="rackStatusFilter">{props.t("Estado")}</Label>
              <Input
                type="select"
                id="rackStatusFilter"
                value={status}
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                <option value="">{props.t("Todos")}</option>
                {Object.keys(rack_status).map((code) => (
                  <option key={code} value={code}>
                    {rack_status[code].name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="mb-0">
              <Label htmlFor="rackCarrierTypeFilter">{props.t("Tipo de carrier")}</Label>
              <Input
                type="select"
                id="rackCarrierTypeFilter"
                value={carrierTypeFilter}
                onChange={(e) => handleCarrierTypeChange(e.target.value)}
              >
                <option value="">{props.t("Todos")}</option>
                {(props.carrierTypes || []).map((code) => (
                  <option key={code} value={code}>
                    {code} - {carrier_type[code] || code}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <EntriesSelector
            label={props.t("Show racks")}
            size={size} setSize={setSize}
            setPage={setPage}
            getEntries={props.getRacks}
            extraArgs={[status, carrierTypeFilter, search]}
        />
        <MDBDataTable responsive striped bordered data={props.rackList}
        paginationLabel={[props.t("Previous"), props.t("Next")]}
        entriesLabel={props.t("Show racks")}
        noRecordsFoundLabel={props.t("No matching records found")}
          infoLabel={[
              props.t("Showing"),
              props.t("to"),
              props.t("of"),
              props.t("entries"),
            ]}
        searching={false}
        paging={false}
        />
        <PaginationButtons
          size={size}
          page={page} setPage={setPage}
          totalPages={props.totalPages}
          getEntries={props.getRacks}
          extraArgs={[status, carrierTypeFilter, search]}
          nextBtnLabel={props.t("Next")}
          prevBtnLabel={props.t("Previous")}
          t={props.t}
        />
      </React.Fragment>
    );
}

const mapStateprops = (state) => {

  return {
  
  };
};
export default withRouter(
  connect(mapStateprops, { })(withNamespaces()(RackList))
);
